"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Editor = void 0;
var Editor_1 = require("./components/Editor");
Object.defineProperty(exports, "Editor", { enumerable: true, get: function () { return Editor_1.Editor; } });



//////////////////
// WEBPACK FOOTER
// ./~/@tinymce/tinymce-react/lib/cjs/main/ts/index.js
// module id = 472
// module chunks = 0